<template>
    <div>
        <div class="w-100" data-aos="fade-up" data-aos-duration="600" data-aos-delay="150">
            <div class="row"  v-if="addresses.length == 0">
                <div class="col-12">
                    <div class="w-100 separate-top mt-3"></div>
                    <p class="mb-4 pt-4 simple-text">
                        {{$root.translateString('no-addresses')}}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 pb-4">
                    <div class="brand-btn mt-0 mt-md-3">
                        <a href="javascript:void(0)" @click="addNewAddress" class="full py-2 text-center">
                            <span class="my-1">
                                 {{$root.translateString('create-new-address')}}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="row pt-3" v-if="addresses.length > 0">
                <div class="col-12 col-md-6 col-lg-4" v-for="(address, index) in addresses" :key="index">
                    <div class="address-block p-3">
                        <div class="col-12">
                            <p class="">
                                <span class="w-100 pb-1 d-block text-gold pt-2">{{address.name}}</span>
                                {{address.address}}<br>
                                {{address.cap}}<br>
                                {{address.city}} ({{address.province}})<br>
                            </p>
                            <p class="text-uppercase default-slot" :class="{'transparent' : !address.default}">
                                <span v-if="address.default">
                                    <small class="p-1">{{$root.translateString('default')}}</small>
                                </span>
                                <span v-else>&nbsp;</span>
                            </p>
                            <div class="carrello-item__remove-btn standalone-close">
                                <a href="javascript:void(0)" @click="deleteAddress(address.id)">
                                    <img src="/images/svg/as-1.svg" width="22" alt="icona" />
                                </a>
                            </div>
                            <div class="actions pt-1">
                                <p class="text-smaller-85 mt-4 mb-0 d-inline-flex">
                                    <small>
                                        <span class="brand-btn ml-0">
                                            <a href="javascript:void(0)" class="logout" @click="editAddress(address)">
                                                <span>{{$root.translateString('edit')}}</span>
                                            </a>
                                        </span>
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <new-address-popup :lang="lang" :provinces="provinces"></new-address-popup>
        <delete-address-popup></delete-address-popup>
        <transition name="fade">
            <div class="loader-checkout d-flex align-items-center justify-content-center" v-if="loading">
                <img width="40" src="/images/loader.svg" alt="loader"/>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    props: ['lang', 'addresses', 'provinces'],
    data() {
        return {
            loading: false,
            address: {
                id: null,
                name: '',
                address: '',
                city: '',
                cap: '',
                province: '',
                default: false,
            },
        }
    },
    mounted() {
    },
    methods: {
        deleteAddress(id) {
            this.$eventHub.$emit('show-delete-address-modal', id);
        },
        editAddress(address_to_edit) {
            this.address_to_edit = address_to_edit;
            this.$eventHub.$emit('show-address-modal', address_to_edit);
        },
        addNewAddress() {
            this.$eventHub.$emit('show-address-modal');
        },
    },
    beforeDestroy() {
    },
    computed: {
    }
}
</script>
